$(function() {
    $('#header .submenu a').each(function(){
        var $this = $(this)
        if($this.hasClass('active')){
            $this.closest('.is-dropdown-submenu').prev().addClass('active')
            $this.closest('.is-accordion-submenu').prev().addClass('active')
        }
    })

    $('.menu-icon').on('click', function(){
        $(this).toggleClass('active')
    })

    // Modal
    $('#healthcare-modal').foundation()
    let link

    if(!$('body').hasClass('for-healthcare-professionals')){
        $('.healthcare-page').on('click', function(e){
            e.preventDefault()
            link = $(this).data('href')

            if (typeof $.cookie('healthcare-modal') === 'undefined'){
                $('#healthcare-modal').foundation('open')
            } else {
                window.location.href = link
            }
        })

        $('#healthcare-modal').on('click', '.proceed', function(e){
            e.preventDefault()
            $.cookie('healthcare-modal', '1', { path: '/' })
            window.location.href = link
        })

        $('#healthcare-modal').on('click', '.cancel', function(e){
            $('#healthcare-modal').foundation('close')
        })
    }
})